import { render, staticRenderFns } from "./GlobalDispatchFooter.vue?vue&type=template&id=5cf3545a&scoped=true&name=global-dispatch-footer&"
import script from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDispatchFooter.vue?vue&type=style&index=0&id=5cf3545a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3545a",
  null
  
)

export default component.exports